import re from '@/api/wholesale/receipt'
import moment from 'moment'
import { uniqBy } from 'lodash'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  dateRange: [moment().add(-7, 'days').format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
  invoices: []
}

export const getters = {
  filterInvoice: state => stockOutId => {
     return state.invoices.filter(e => e.stock_out_id == stockOutId && e.amount_due > 0).reduce((i,v) => i = v, null)
  },
  customerList: state => {
      return uniqBy(state.invoices.map(el => ({
        value: el.customer.customer_id,
        label: el.customer.customer_name
      })), 'value')
  }
}

export const mutations = {
  ...baseMutations,
  SET_DATE_RANGE(state, date){
    state.dateRange = date
  },
  SET_INVOICE_LIST(state, data){
    state.invoices = data
  },
  UPDATE_AMOUNT_DUE(state, { stockOutId, amount }) {
    let filter = state.invoices.filter(e => e.stock_out_id == stockOutId).reduce((i,v) => i = v, null)
    filter.amount_due = amount
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search,
          date_between: _.join(context.state.dateRange, ',')
        }
      },
      attrubutes
    )
    return re.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return re.store(data)
  },
  async fetchData(context) {
    let response = await re.getInvoice()
    context.commit('SET_INVOICE_LIST', response.data)
  },
  reprint(context, id){
    return re.reprint(id)
  },
  destroy(context, { id, data }){
    return re.destroy(id, data)
  },
  bankProfile(context, attributes = {}){
    return re.bankProfile()
  },
}
